// @flow
import { FETCH_PROPOSALS } from 'Store/booking/proposals/constants';
import { type BookingEngineEntry } from 'Store/booking/constants';

type BookingEngineEntryState = null | BookingEngineEntry;

const initialState = null;

export function bookingEngineEntry(
  state: BookingEngineEntryState = initialState,
  action: Action<{ bookingEngineEntry: BookingEngineEntryState }>,
): BookingEngineEntryState {
  switch (action.type) {
    case FETCH_PROPOSALS: {
      return action.payload.bookingEngineEntry;
    }
    default:
      return state;
  }
}
